import React from 'react'
import PasswordChecklist from 'react-password-checklist'

export default class PasswordInput extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            password: '',
            passwordConfirm: ''
        }
    }

    updatePassword(value) {
        this.setState({
            password: value
        })
    }

    updateConfirmPassword(value) {
        this.setState({
            passwordConfirm: value
        })
    }

    render () {
        return (
            <div>
                <div className={`mb-3 ${this.props.layout === 'row' ? 'd-flex flex-row' : ''}`}>
                    <div className={`mt-3 ${this.props.layout === 'row' ? 'col-sm-6 pl-0' : ''}`}>
                        <div className="w-100 input-group mt-1">
                            <input id="password" type="password"
                                placeholder={this.props.label} required={this.props.required !== 'false'}
                                className="form-control input password_reset_field"
                                name="password" autoComplete="new-password"
                                onChange={e => this.updatePassword(e.target.value)}/>

                            <div className="input-group-append showpassword showpassword-lite">
                                <span className="input-group-text login-password-icon"><i className="fas fa-eye-slash"></i></span>
                            </div>
                        </div>
                    </div>
                    <div className={`mt-3 ${this.props.layout === 'row' ? 'col-sm-6' : ''}`}>
                        <div className="w-100 input-group mt-1">
                            <input id="password-confirm" type="password"
                                placeholder={this.props.confirmLabel} required={this.props.required !== 'false'}
                                className="form-control input password_reset_field" name="password_confirmation"
                                autoComplete="new-password"
                                onChange={e => this.updateConfirmPassword(e.target.value)}/>

                            <div className="input-group-append showpassword showpassword-lite">
                                <span className="input-group-text login-password-icon"><i className="fas fa-eye-slash"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
                {((this.props.defaultShowRules !== "false") || (this.state.password.length > 0 || this.state.passwordConfirm.length > 0)) && (
                    <PasswordChecklist 
                        rules={['minLength', 'specialChar', 'number', 'capital', 'match']}
                        minLength={6}
                        value={this.state.password}
                        valueAgain={this.state.passwordConfirm}
                        onChange={(isValid) => {
                        const saveBtn = document.getElementsByClassName('password-save-btn')[0];
                        if (saveBtn) {
                            saveBtn.disabled = !isValid;
                        }
                        }}
                    />
                )}
            </div>
        )
    }
}
